<template>
  <div id="container">
    <div id="login_bg">
      <div class="Login_left">
        <div class="Login_left_img"></div>
        <p>Card Hobby Seller Center</p>
      </div>
      <div id="LoginBox" v-loading="disabled">
        <div class="login_logo">
          <a href="/" class="logo"></a>
          <h1 style="line-height:24px;">{{ $t('login.welcome') }}</h1>
        </div>
        <div class="login_tab">
          <div :class="{ 'on': ruleForm.Type == '1' }" @click="ruleForm.Type = '1'">{{ $t('login.phoneNumber') }}</div>
          <div :class="{ 'on': ruleForm.Type == '0' }" @click="ruleForm.Type = '0'">{{ $t('login.email') }}</div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="LoginForm">
          <el-form-item class="login_form_item" prop="Account">
            <!-- 国籍 -->
            <div class="locationPhoneBox login_location" v-if="ruleForm.Type == '1'">
              <div class="countries" v-if="location.MemberSource != ''">
                <img :src="location.LocationIcon" alt="">
              </div>
              <el-select class="login_ipt" :class="location.MemberSource != '' ? 'nolocation' : ''" placeholder="" v-model="location.MemberSource" popper-class='location' @change='changeLocation'>
                <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item, index) in locationOption" :key='index'>
                  <div class="locationOption">
                    <img :src="item.IconUrl">
                    <span>{{ item.EnName }}</span>
                  </div>
                </el-option>
              </el-select>
              <div class="nationCode">
                {{ location.AreaCode }}
              </div>
            </div>
            <!-- 手机号/邮箱 -->
            <!-- <el-input class="login_ipt first_login_ipt" v-model="ruleForm.Account" placeholder="Enter your email" @input='emailInput'></el-input> -->
            <el-input class="login_ipt first_login_ipt" :class="{ 'email': ruleForm.Type == '1' }" v-model="ruleForm.Account" :placeholder="ruleForm.Type == '1' ? $t('login.phoneText') : $t('login.emailText')" autocomplete="off" @input='emailInput'></el-input>
          </el-form-item>
          <el-form-item style="" class="login_form_p login_form_item" prop="password">
            <!-- show-password -->
            <el-input class="login_ipt password_ipt login_ipt_m" :type="flagType" v-model="ruleForm.password" :placeholder="$t('login.passwordText')" @input="search">
              <i slot="suffix" class="showing" :class="[flag == true ? 'show' : 'noshow']" v-show="ifshow" @click="getFlag()" />
            </el-input>
          </el-form-item>
          <div class="forgot" v-if="ruleForm.Type == '0'">
            {{ $t('login.forgot') }}
            <span class="btns text_blue" @click="goto('LoginForm')">{{ $t('login.reset') }}</span>
          </div>
          <el-button class="text_btn" :disabled="disabled" type="primary" @click="submitForm('LoginForm')">{{ $t('button.login') }}</el-button>
        </el-form>

        <div class="terms_checked">
          <!-- <el-checkbox v-model="checked"></el-checkbox> -->
          <el-checkbox v-model="checkbox" :label="1">{{ checkboxNumber }}</el-checkbox>
          <div>
            {{ $t('agreement.read') }}
            <!-- <a :href="CARD_URL+'/#/terms/privacy?type=2'" target="_blank"><span class="text_blue">Terms of Service</span></a> and
            <a :href="CARD_URL+'/#/terms/privacy?type=1'" target="_blank"><span class="text_blue">Privacy Policy</span></a> -->
            <span class="agree-btn text_blue" @click="GetAgreements($t('agreement.service'), 2)">{{ $t('agreement.service') }}</span>
            {{ $t('agreement.and') }}
            <span class="agree-btn text_blue" @click="GetAgreements($t('agreement.policy'), 1)">{{ $t('agreement.policy') }}</span>
          </div>
        </div>
    <change-lang></change-lang>
        <!-- <div class="account_box">
        Don't have an account yet? <router-link class="text_blue" :to="{path:'/register'}">Sign up now</router-link>
      </div> -->
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <div class="dialog_box" style="width:450px">
        <div class="" style="margin:16px 0 10px">
          {{ $t('agreement.plsAgree') }}
          <span class="btns text_blue" @click="GetAgreements($t('agreement.service'), 2)">{{ $t('agreement.service') }}</span> {{ $t('agreement.and') }} <span class="btns text_blue" @click="GetAgreements($t('agreement.policy'), 1)">{{ $t('agreement.policy') }}</span>
          .
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="isChecked">{{ $t('button.agree') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="AgreementTitle" :visible.sync="AgreementVisible" width="80%" @close="handleAgreementsClose">
      <div class="agreementsMain" v-loading="AgreementsLoading" v-html="Agreements"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="AgreementVisible = false">{{ $t('button.done') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import changeLang from '@/components/change-lang'
export default {
  name: 'index',
  components: {changeLang},
  data() {
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.wrong')));
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    var passValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('login.wrong')));
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    return {
      CARD_URL: process.env.VUE_APP_CARD_URL,
      flagType: 'password',
      flag: false,
      dialogTitle: "",
      dialogVisible: false,
      smsMsg: '',
      disabled: false,
      // checked: false,
      checkboxNumber: '',
      checkbox: false,
      ifshow: false,
      locationOption: '',
      location: {
        MemberSource: '',
        LocationIcon: '',
        LocationName: '',
        AreaCode: ''
      },
      ruleForm: {
        email: '',
        Account: '',//邮箱或手机
        password: '',
        Type: '1',//登录类型 0邮箱 1手机号
        AreaCode: ''//手机区号
      },
      rules: {
        Account: [
          { required: true, message: this.$t('login.emailTip'), trigger: 'blur' },
          // { type: 'email', message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          { validator: userValidate }
        ],
        password: [
          { required: true, message: this.$t('login.passwordTip'), trigger: 'blur' },
          { validator: passValidate }
        ]
      },
      Agreements: "",
      AgreementTitle: "",
      AgreementVisible: false,
      AgreementsLoading: false
    }
  },
  created() {
    this.getNationIcons()
  },
  mounted() {

    let that = this
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 13) {
        that.submitForm('LoginForm')
      }
    })
    // if (!this.$store.state.UserInfo.Id) {
    //   // location.href = '/';
    // }
    // console.log(this.$interface.SignIn)

    //let exdate = this.$store.state.exdays;
    // console.log(exdate);
  },
  methods: {
    //是否显示查看密码的图标
    search() {
      if (this.ruleForm.password.length > 0) {
        this.ifshow = true
      } else {
        this.ifshow = false
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
      //alert(111)
    },
    // 删除email清空密码
    emailInput() {
      if (this.ruleForm.Account.length < 1) {
        this.ruleForm.password = ''
      }
    },
    // 点击同意隐私协议选中，弹框关闭
    isChecked() {
      this.dialogVisible = false
      this.checkbox = true
      this.submitForm('LoginForm');
    },
    // 隐私协议弹框
    dialog() {
      this.dialogVisible = true;
      this.dialogTitle = this.$t('enum.notice');
    },
    // 跳转到忘记密码，并携带数据
    goto(formName) {
      let that = this;
      that.$refs[formName].validateField("Account", (val) => {
        console.log(val);
        this.$router.push({
          path: '/forgot',
          query: {
            email: that.ruleForm.Account
          }
        })
      })
      // this.$router.push({
      //   path: '/forgot',
      //   query: {
      //   email: that.ruleForm.email
      //   }
      // })
    },
    // 登录
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checkbox == false) {
            this.dialog()
            //   this.$alert('To proceed, please agree to the Terms of Service and PrivacyPolicy.', 'Notice',{showConfirmButton:true});
          } else {
            this.disabled = true;
            var formData = this.ruleForm;
            formData['email'] = that.ruleForm.Account;
            var data = { 'UserApi': 'UserApi', ...formData }
            that.$post('SignIn', data)//登录
              .then((res) => {
                console.log("axios-res:", res);

                if (res.Result) {
                  var UserInfo = res.Data
                  if (UserInfo.IsSeller) {
                    let str = this.ruleForm.Account;
                    str = UserInfo['EMail'].split('@');
                    if (str[0].length <= 3) { str[0] = str[0].substr(0, 1) }
                    else { str[0] = str[0].substr(0, 3); }
                    UserInfo["Email"] = str[0] + "*********@" + str[1];

                    let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.VUE_APP_DOMAIN;
                    //登录后如获取不到用户信息去除以下domain
                    that.$cookie.set('cardUser', JSON.stringify(UserInfo), {
                      expires: that.$store.state.exdays, domain
                    });
                    that.$store.dispatch("getUserDetail", UserInfo)
                    
                  } else {
                    that.disabled = false;
                    that.$message.error(this.$t('enum.noPermissions'));
                  }
                } else {
                  that.disabled = false;
                  let Msg = res.Msg || this.$t('login.loginFailed');
                  // that.$message.error(Msg);
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }
        }
      });
    },
    // 弹框
    GetAgreements(AgreementTitle, type) {
      let that = this;
      that.AgreementTitle = AgreementTitle;
      that.AgreementsLoading = true;
      that.AgreementVisible = true;
      that.Agreements = "";
      this.$get("GetNewServiceAgreements", `?ServiceAgreementType=${type}`).then(res => {//获取国外有效合规文档
        if (res.Result) {
          if (res.Data.length > 0) {
            that.Agreements = res.Data[0]["Content"];
          }
        } else {
          that.Agreements = "";
          // that.AgreementVisible = false;
        }
        that.AgreementsLoading = false;
      }).catch(err => {
        that.AgreementVisible = false;
        that.AgreementsLoading = false;
        that.Agreements = "";
      })
    },
    // 关闭协议弹框
    handleAgreementsClose() {
      this.Agreements = "";
      this.AgreementVisible = false;
      this.AgreementsLoading = false;
    },
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.location.MemberSource = res.Code //
          that.location.LocationIcon = res.IconUrl
          that.location.LocationName = res.EnName
          that.location.AreaCode = res.NationCode
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this;
      this.$get("GetAllNationIcons", '').then(res => {
        if (res.Result != 0) {
          that.locationOption = res.Data
          that.location.MemberSource = res.Data[0].Code //
          that.location.LocationIcon = res.Data[0].IconUrl
          that.location.LocationName = res.Data[0].EnName
          that.location.AreaCode = res.Data[0].NationCode
          that.ruleForm.AreaCode = res.Data[0].NationCode
          setTimeout(() => {
            this.$refs.LoginForm.clearValidate();
          }, 10);
        }
      })
    },
  }
}
</script>

<style scoped>
@import "../../../static/css/login.css";

/deep/ .el-form-item__error {
  top: auto;
}

/deep/ .el-checkbox__inner {
  border-color: #a0a0a0;
}

/* /deep/.login_form_p .el-input__inner{
  background: url(../../../static/images/icons/icon_check_off.svg) no-repeat right;
} */
</style>



// WEBPACK FOOTER //
// src/pages/shared/login.vue